export default [
    {
        title: 'مدیریت سفارش ها',
        icon: 'bx bx-chalkboard',
        children: [
            {
                title: 'سفارش ها',
                route: { name: 'order' },
                resource: 'OrderManager',
                action: 'show',
            },
        ],
    },
]
